import { ICON_SIZE } from '@components/v2/constants';
import { DetailsToggleAlert } from '@components/v2/layout/ObjectScreen/objectScreen.types';
import Loading from '@components/v2/ui/Loading/Loading';
import { OrderConditionsTestIds } from '../../../../utils/testIds/OrderConditions.testIds';
import { OrderObjectTestIds } from '../../../../utils/testIds/OrderObject.testIds';
import { Customer } from '../../../customer/types/customer.types';
import OrderValidationErrorsTooltipContent from '../../edit/validate/components/OrderValidationErrorsTooltipContent';
import OrderErrorIcon from './components/OrderErrorIcon';

export const getOrderCustomerBreadcrumbLabel = (customer?: Pick<Customer, 'commercialName'>) =>
  customer?.commercialName ?? '';

interface GetConditionsTabEndIconParams {
  isValidating: boolean;
  hasErrors: boolean;
  onClick?: () => void;
}

export const getConditionsTabEndIcon = ({
  isValidating,
  hasErrors,
  onClick,
}: GetConditionsTabEndIconParams) => {
  if (isValidating) {
    return <Loading size={ICON_SIZE.sm} testId={OrderConditionsTestIds.TAB_VALIDATING} />;
  }

  if (!hasErrors) {
    return undefined;
  }

  return (
    <OrderErrorIcon testId={OrderConditionsTestIds.CONDITION_TAB_ERROR_ICON} onClick={onClick} />
  );
};

interface GetDetailsToggleAlertParams {
  hasErrors: boolean;
  errors: string[];
}

export const getDetailsToggleAlert = ({
  hasErrors,
  errors,
}: GetDetailsToggleAlertParams): DetailsToggleAlert | undefined => {
  if (!hasErrors) {
    return undefined;
  }

  return {
    icon: <OrderErrorIcon testId={OrderObjectTestIds.DETAILS_TOGGLE_ERROR_ICON} />,
    tooltip: <OrderValidationErrorsTooltipContent errors={errors} />,
  };
};
